import { render, staticRenderFns } from "./tracker-organizations-by-region-widget.vue?vue&type=template&id=c4c4b7da&scoped=true&"
import script from "./tracker-organizations-by-region-widget.vue?vue&type=script&lang=js&"
export * from "./tracker-organizations-by-region-widget.vue?vue&type=script&lang=js&"
import style0 from "./tracker-organizations-by-region-widget.vue?vue&type=style&index=0&id=c4c4b7da&prod&scoped=true&lang=css&"
import style1 from "./tracker-organizations-by-region-widget.vue?vue&type=style&index=1&id=c4c4b7da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c4b7da",
  null
  
)

export default component.exports